export class Settings {
    //Authority for Reyes Holdings
    public static _OAUTH_AUTHORITY = 'https://login.microsoftonline.com/ff1b190b-edf8-459d-8237-0545497adf7a';

    //ClientID for Reyes Holdings
    public static _OAUTH_CLIENT_ID = '68a72037-3605-4943-bb7e-3bf9104eb66c';

    //Values to be set by the pipeline
    public static _OAUTH_REDIRECTURI = 'https://rccb-ariesdev.reyesholdings.com';

    public static _URL_BASE = 'https://rccb-ariesdev-api.reyesholdings.com/api';

    public static _UI_VERSION = "2.17.0";

    public static _API_APPLICATION_ID = "31768b00-4df7-465b-a6d0-32af447eafff";
}

export default Settings;
